export const defaultPostFilter = {
    city: '',
    type: 'all',
    price: 'all',
};